export default __webpack_public_path__ + "static/media/OCI.c9fb1c26.jpg";